import { FaUtensils } from 'react-icons/fa';
import images from './images';

const pricing = [
  {
    id: 1,
    image: images.plan1,
    icon: <FaUtensils />,
    title: 'Standard Package',
    price: 49.00,
    note: 'per person',
    features: [
      '3-Course Meal',
      'Complimentary Drink',
      'Access to Exclusive Menu Items',
      'Reserved Seating',
      'Personalized Service',
    ],
  },
  {
    id: 2,
    image: images.plan2,
    icon: <FaUtensils />,
    title: 'Family Package',
    price: 129.00,
    note: 'for 4 people',
    features: [
      '4-Course Meal',
      'Complimentary Bottle of Wine',
      'Special Kids Menu',
      'Reserved Family Table',
      'Discount on Additional Orders',
    ],
  },
  {
    id: 3,
    image: images.plan3,
    icon: <FaUtensils />,
    title: 'Premium Package',
    price: 199.00,
    note: 'for 2 people',
    features: [
      '5-Course Gourmet Meal',
      'Premium Wine Pairing',
      'Exclusive Chef\'s Table Experience',
      'Personalized Menu Options',
      'Priority Reservation',
    ],
  },
];

export default pricing;